<template>
  <div id="Selector">
    <div class="card-selector">
      <div class="title">카드 선택</div>
      <div class="guide">국내카드사 외 해외카드 3개사 (VISA, Master, JCB)로만 결제 가능합니다.</div>
      <div class="card-list">
        <div class="card-item" v-for="(card, idx) in cardList" :key="idx" @click="selectCard(idx)">
          <span class="card-item-text" :style="{ 'color': idx === selectedCard ? getColor.primaryColor : '#000' }">{{card.text}}</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"  class="card-item-radio" :style="{ fill: idx === selectedCard ? getColor.primaryColor : '#d8d8d8' }">
            <path fill-rule="evenodd" d="M21 11c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 5.333c-2.577 0-4.667 2.09-4.667 4.667s2.09 4.667 4.667 4.667 4.667-2.09 4.667-4.667-2.09-4.667-4.667-4.667z"/>
          </svg>
        </div>
      </div>
    </div>
    <div class="button-group">
      <button id="nextStep" :style="styleObject" @click="nextStep">다 음</button>
    </div>
  </div>
</template>

<script>
import vuex from 'vuex'

export default {
  data () {
    return {
      cardList: [
        { text: 'VISA', value: 'visa' },
        { text: 'Master', value: 'master' },
        { text: 'JCB', value: 'jcb' },
      ],
      selectedCard: 0,
      radioSvg: require('../../images/radio-on.svg')
    }
  },
  computed: {
    ...vuex.mapGetters({
      'getColor': 'style/getColor'
    }),
    styleObject: function() {
      return {
        '--color': this.getColor.primaryColor,
        '--color-active': this.getColor.primaryColorDark
      }
    }
  },
  methods: {
    ...vuex.mapActions({
      'SET_OVERSEAS_PAYMENT_TYPE': 'SET_OVERSEAS_PAYMENT_TYPE'
    }),
    selectCard(idx) {
      this.selectedCard = idx;
    },
    async nextStep() {
      await this.SET_OVERSEAS_PAYMENT_TYPE(this.cardList[this.selectedCard]);

      this.$router.push('/payment/global')
    }
  }
}
</script>

<style lang="scss">
#Selector {
  @include basic-display;

  padding: 30px 20px 81px;

  .card-selector {
    .title {
      height: 34px;
      padding: 0 10px;

      font-size: 24px;
      font-weight: bold;

      line-height: 1.42;
    }
    .guide {
      height: 40px;
      margin-top: 5px;
      padding: 0 10px;

      font-size: 13px;
      color: #424242;
      
      line-height: 1.54;
      word-break: keep-all;
    }
    
    .card-list {
      margin-top: 20px;

      .card-item {
        position: relative;
        height: 60px;
        border-radius: 18px;
        border: solid 1px #e0e0e0;

        background-color: white;
        // background-image: url('../../images/radio-on.svg');
        // background-size: 42px;
        // background-position: right 10px center;
        // background-repeat: no-repeat;

        &:not(:first-child) {
          margin-top: 6px;
        }

        .card-item-text {
          display: inline-block;
          height: 60px;
          padding-left: 20px;

          font-size: 17px;
          font-weight: bold;

          line-height: 60px;
        }

        .card-item-radio {
          position: absolute;
          right: 10px;
          height: 60px;
        }
      }
    }
  }

  .button-group {
    z-index: 1000;
    position: fixed;

    right: 0; bottom: 0; left: 0;

    #nextStep {
      width: 100%;
      height: 60px;

      font-size: 24px;

      background-color: var(--color);
      color: white;

      &:active {
        background-color: var(--color-active);
      }
    }
  } 
}
</style>